module.exports = __webpack_public_path__ + "static/media/Upload-Prescription.47874bcf.png";